import { normalizeSchedules } from '../../../../Instruments/utils/multiSchedule'
import { getInstrumentChainTriggerIds } from './legacy/instrumentChainStudyDay'

/**
 * Topological order for instrument chaining (parents before children).
 * Instruments with no triggers come first; cycles are broken by skipping unresolved edges.
 */
export const buildInstrumentDependencyOrder = (instruments = []) => {
  const byId = new Map()
  instruments.forEach(inst => {
    if (inst?.id != null) byId.set(String(inst.id), inst)
  })

  const edges = new Map()
  byId.forEach((inst, id) => {
    const triggers = new Set()
    normalizeSchedules(inst.metadata?.schedule).forEach(schedule => {
      getInstrumentChainTriggerIds(schedule).forEach(tid => {
        if (byId.has(String(tid))) triggers.add(String(tid))
      })
    })
    edges.set(id, triggers)
  })

  const ordered = []
  const visited = new Set()
  const visiting = new Set()

  const visit = id => {
    if (visited.has(id)) return true
    if (visiting.has(id)) return false
    visiting.add(id)
    const deps = edges.get(id) || new Set()
    for (const dep of deps) {
      if (!visit(dep)) return false
    }
    visiting.delete(id)
    visited.add(id)
    ordered.push(byId.get(id))
    return true
  }

  byId.forEach((_, id) => {
    if (!visited.has(id)) visit(id)
  })

  const missing = instruments.filter(i => i?.id != null && !visited.has(String(i.id)))
  return [...ordered, ...missing]
}

export const collectInstrumentTriggers = instruments => {
  const graph = new Map()
  instruments.forEach(inst => {
    if (inst?.id == null) return
    const triggers = []
    normalizeSchedules(inst.metadata?.schedule).forEach(schedule => {
      triggers.push(...getInstrumentChainTriggerIds(schedule))
    })
    graph.set(String(inst.id), triggers)
  })
  return graph
}
